import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ProgramStatusService } from '@ebb-v2/ebb-integration';
import { AccountsService } from './modules/registration/services/accounts/accounts.service';

@Component({
  selector: 'hom-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class HomeownerAppComponent {
  public programTypeCodeOptionSet: string;
  constructor(private accountsService: AccountsService,
    private router: Router,
    
    private programstatus:ProgramStatusService){

    }
    public ngOnInit(): void {
      this.programTypeCodeOptionSet = this.accountsService.programTypeCodeOptionSet;
      this.programstatus.checkProgramstatus(this.programTypeCodeOptionSet).subscribe((data) => {
        if(!data){
          var ProgramType =this.programTypeCodeOptionSet;
          if(ProgramType.includes("FEMA") || ProgramType.includes("EBB"))  {
            ProgramType = "ebb";
          }
          if(ProgramType.includes("ESS"))  {
            ProgramType = "ess";
          }
          if(ProgramType.includes("CEA BB"))  {
            ProgramType = "ceabb";
          }
          this.router.navigate(['status', ProgramType]);
        }
        })}
 }
 


